import { logicChapterOfLevel } from "./chapters.ts";
import { LOGIC_CONTENT_VERSION, LOGIC_PACK_LOADERS } from "./packs.generated.ts";
import { logicPackSchema, type LogicLevel, type LogicPack } from "./schema.ts";

const packCache = new Map<number, Promise<LogicPack>>();

/** Loads (once) and validates one Logic Tower chapter pack; nothing of the house downloads before. */
export function loadLogicChapter(chapter: number): Promise<LogicPack> {
  let pending = packCache.get(chapter);
  if (!pending) {
    const loader = LOGIC_PACK_LOADERS[chapter];
    if (!loader) return Promise.reject(new Error(`no logic pack for chapter ${chapter}`));
    pending = loader().then((raw) => {
      const pack = logicPackSchema.parse(raw);
      if (pack.contentVersion !== LOGIC_CONTENT_VERSION) throw new Error(`pack ${chapter} has version ${pack.contentVersion}`);
      return pack;
    });
    pending.catch(() => packCache.delete(chapter));
    packCache.set(chapter, pending);
  }
  return pending;
}

export async function loadLogicLevel(levelId: number): Promise<LogicLevel> {
  const pack = await loadLogicChapter(logicChapterOfLevel(levelId).chapter);
  const level = pack.levels.find((candidate) => candidate.id === levelId);
  if (!level) throw new Error(`logic level ${levelId} missing from pack`);
  return level;
}
